<template>
  <div class="pb-0 mb-0">
    <v-btn small class="ma-0" @click="$router.back()" color="info" rounded outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn
    >
    <h4 class="text-primary text-center mt-0 pt-0 mb-0">ASIGNACION TOTAL POR PROGRAMA.</h4>

    <v-row dense class="ml-2">
      <v-col cols="12" sm="6" md="3">
        <v-menu
          v-model="menu2"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="date"
              label="Seleccione la fecha:"
              prepend-icon="mdi-calendar"
              readonly
              outlined
              dense
              v-bind="attrs"
              v-on="on"></v-text-field>
          </template>
          <v-date-picker v-model="date" @input="menu2 = false"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" sm="2">
        <v-text-field v-model.number="xcuota" label="Cuota:" type="number" dense outlined />
      </v-col>
      <v-col cols="12" sm="2">
        <v-select
          v-model="gestion"
          :items="gestiones"
          :loading="loading_gestiones"
          label="Gestion:"
          item-value="id"
          dense
          hide-details
          outlined></v-select>
      </v-col>
      <v-col class="pl-1 pr-1" cols="12" sm="3">
        <v-select
          v-model="programa_id"
          :items="programas"
          :loading="loading_programas"
          label="Programa:"
          item-value="id"
          dense
          hide-details
          outlined></v-select>
      </v-col>
      <v-col cols="12" sm="3" md="4">
        <v-switch
          v-model="only_cuota"
          :label="only_cuota ? 'Mostrar desde cuota seleccionada' : 'Mostrar solo cuota seleccionada'"
          :disabled="loading"
          dense
          hide-details
          title="Mostrar datos de la cuota seleccionada."
          class="mb-4"></v-switch>
      </v-col>
      <v-col cols="12" sm="2" md="3">
        <v-btn class="blue darken-2" dark tile :disabled="loading" @click="obtenerasignaciones()">Calcular</v-btn>
      </v-col>
    </v-row>
    <p class="text-center text-danger pa-0" v-if="msg">
      <b>{{ msg }}</b>
    </p>
    <v-progress-linear indeterminate v-if="loading" class="mt-2" />
    <p class="mb-0" v-if="xname">
      <b>Asignacion de la unidad: {{ xname }}</b>
    </p>

    <div v-if="datos.length > 0" class="text-right">
      <v-btn dense tile color="purple" outlined dark class="mb-1" small @click="tableToExcel('table2')">
        <v-icon left>mdi-download</v-icon> Descargar excel
      </v-btn>
    </div>

    <div class="table-responsive">
      <table class="ztable table-hover" ref="table2">
        <thead>
          <tr class="white--text">
            <template v-for="(r, ind) in rotulos">
              <th v-if="r != 'idestudiante'" :key="ind" :class="r == 'nombre' ? 'fixedheader' : 'green darken-4'">
                {{ getrotuloparse(r) }}
              </th>
            </template>
          </tr>
        </thead>

        <tbody>
          <template v-for="(sede, ind) in datos">
            <tr :key="ind">
              <template v-for="(r, ind) in rotulos">
                <td v-if="r != 'idestudiante'" :key="ind">{{ getfromkey(sede, r, false) }}</td>
              </template>
            </tr>
          </template>

          <tr>
            <template v-for="(t, ind) in Object.keys(totales)">
              <td v-if="t != 'idestudiante'" :key="ind" class="xrowtotal">{{ getfromkey(totales, t, true) }}</td>
            </template>
          </tr>
        </tbody>
      </table>
    </div>

    <toexcel ref="toexcel" />
  </div>
</template>

<style>
  @import url('./stilotablas.css');
</style>

<script>
  import xaxios from '@/xaxios';
  import gql from 'graphql-tag';
  import toexcel from '../proyecciones/toexcel';
  import { listarprogramasgraphql } from '../proyecciones/utils';

  export default {
    data() {
      return {
        gestiones: [],
        programas: [],
        tiposasignacion: [
          { id: 1, text: 'Asignacion' },
          { id: 2, text: 'Inscritos' },
        ],
        loading_gestiones: false,
        loading_programas: false,
        loadingmes: false,
        programa_id: null,
        filtros: {
          gestion: null,
          mes: null,
          tipoasignacion: null,
          unidad: null,
        },
        gestion: null,
        buscar: '',
        datos: [],
        rotulos: [],
        totales: {},
        loading: false,
        msg: '',
        loadingunidades: false,
        omit_filtro: false,

        date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
        menu2: false,
        xcuota: 1,
        only_cuota: true,
        unidades: [],
        xname: '',
      };
    },
    watch: {
      '$store.state.CARGO.sede': function () {
        this.obtenerasignaciones();
      },
      '$store.state.convenio': function () {
        if (this.$store.state.convenio) {
          this.obtenerasignaciones();
        }
      },
      gestion: function () {
        this.getProgramas();
      },
    },
    components: { toexcel },
    methods: {
      tableToExcel(table) {
        if (!table.nodeType) table = this.$refs[table];
        this.$refs.toexcel.tableToExcel(table, 'asig-total-programas.xls');
      },
      dataloaded() {
        this.loading = false;
      },
      obtenerasignaciones() {
        if (!this.programa_id) return;
        if (this.loading) return;
        this.loading = true;

        this.getfromserver();
      },
      async getProgramas() {
        this.loading_programas = true;
        let res = await listarprogramasgraphql(this);
        window.console.log(res);
        this.programas = res;
        this.loading_programas = false;
      },
      getrotuloparse(key) {
        if (key == 'xtotal') return 'TOTAL';
        else if (key == 'nombre_completo') return 'Estudiantes';
        let fs = key.split('_');
        return fs.join(' ');
      },
      getfromkey(obj, key, ultimarow) { 
        if( key == 'inscripcion_id') return ''
        if( key == 'contacto') return obj[key]
        if( key == 'estado_ins' ) {
          const ins = obj[key]
          let str = ''
          if(ultimarow) return '' 
          
          if (ins == 0) str = 'Pre inscrito';
            else if (ins == 1) str = 'Inscrito';
            else if (ins == 2) str = 'retirado';
            else if (ins == 3) str = 'cambiado';
            else if (ins == 4) str = 'congelado';
            else if (ins == 5) str = 'pagado';
            return str;
          }
        return this.parsecomas(obj[key]);
      },
      parsecomas(str) {
        if (isNaN(str)) return str;
        try {
          if (!str) str = 0;
          let number = window.accounting.formatMoney(str, '', 2, '.', ',');
          return number;
        } catch (e) {
          window.console.error(e);
          return str;
        }
      },
      async getConveniosUniversidades() {
        this.loading_gestiones = true;
        this.programas = [];
        let q = 'query{ getGestiones{gestion} }';
        const sql = gql`
          ${q}
        `;
        this.$apollo.query({ query: sql }).then(({ data }) => {
          data.getGestiones.map((x) => {
            x.text = x.gestion;
            x.id = x.gestion;
          });
          this.gestiones = data.getGestiones.reverse();
          this.gestion = this.gestiones[0].id;
          this.loading_gestiones = false;
          //this.cargarfromserver();
        });
      },
      getfromserver() {
        let p = `programa_id=${this.programa_id}`;
        let urla = `${process.env.VUE_APP_API_REST}/api/v2/esam/asignacion/total/programas?fecha=${this.date} 23:59&nro_cuota=${this.xcuota}&desde=${this.only_cuota}&${p}`;
        const promise2 = xaxios.get(urla);
        let vue = this;
        this.datos = [];
        this.rotulos = [];

        Promise.all([promise2])
          .then(function (values) {
            let data1 = values[0].data;
            let xdatos = data1.data;
            vue.rotulos = window.Object.keys(data1.data[0]);
            vue.totales = JSON.parse(JSON.stringify(data1.data[0]));
            window.Object.keys(vue.totales).forEach((x) => {
              vue.totales[x] = 0;
            });

            vue.rotulos = vue.rotulos.filter((x)=> {return x != 'contactoxxx' && x != "inscripcion_id"})

            // window.console.log('vue.totales',vue.totales);
            

            let totaltotal = 0;
            // let ii = 0
            xdatos.forEach((x) => {
              let keys = window.Object.keys(x);
              let xtotal = 0;
              keys.forEach((k) => {
                if (vue.totales[k] == null) vue.totales[k] = 0;
                if (k != 'idestudiante' && k != 'nombre_completo' && k != 'contacto' && k != 'inscripcion_id' && k != 'estado_ins' && !isNaN(x[k])) {
                  xtotal += x[k];
                  totaltotal += x[k];
                  vue.totales[k] += x[k];
                }
              });
              x.xtotal = xtotal;
              /* if( ii == 0) {
                window.console.log('>>>>>', ii);
                window.console.log('>>>>>', x);
                window.console.log('>>>>>', vue.rotulos);
                ii++
              } */
            });

            vue.rotulos.push('xtotal');
            vue.totales.nombre_completo = 'TOTAL';
            vue.totales.xtotal = totaltotal;
            vue.totales.contacto = '-';
            vue.datos = xdatos;
            // window.console.log(vue.datos, totaltotal);
            vue.loading = false;

            // delete vue.totales['contacto']
            delete vue.totales['inscripcion_id']
          })
          .catch((e) => {
            window.console.error(e);
            vue.loading = false;
          });
      },
    },
    mounted() {
      this.getConveniosUniversidades();
    },
  };
</script>
